import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { ReservationService } from "../services/ReservationService";
import { useNotifications } from "../context/NotificationsContext";

export function NotificationsChecker() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");
  const { addNotification } = useNotifications();
  const intervalRef = useRef(null);

  useEffect(() => {
    // Only check for canceled reservations if not on admin route
    if (!isAdminRoute) {
      const reservationService = new ReservationService();
      const checkCanceledReservations = async () => {
        try {
          const canceledReservations =
            await reservationService.getCanceledReservations();
          if (canceledReservations && canceledReservations.length > 0) {
            console.log("Canceled reservations found:", canceledReservations);
            // Add a notification for each canceled reservation
            canceledReservations.forEach((reservation) => {
              addNotification(reservation);
            });
          }
        } catch (error) {
          console.error("Error checking canceled reservations:", error);
        }
      };

      // Check immediately
      checkCanceledReservations();

      // Set up interval to check every 10 minutes
      intervalRef.current = setInterval(
        checkCanceledReservations,
        10 * 60 * 1000
      );

      // Clean up interval on component unmount
      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      };
    }
  }, [isAdminRoute]);

  return null;
}
